/**
 * Colonne des résultats.
 *
 * Ne s'ouvre jamais d'elle-même : c'est le compteur d'un statut, dans la barre
 * latérale, qui la commande. Le chiffre annonce déjà « 2 clients » — cliquer
 * dessus pour voir ces 2 est le geste évident, et évite un bouton dédié.
 *
 * Elle s'ouvrait autrefois dès qu'un filtre était actif : règle sensée tant que
 * « tous les statuts » était le défaut, absurde depuis que « prospects seuls »
 * l'est — elle surgissait au démarrage avec 810 lignes que personne n'avait
 * demandées.
 */

import { typeOf, visibleEstablishments } from '../domain/filters.js'
import { recordKey } from '../domain/record.js'
import { getState, select, setListOpen } from '../state.js'
import { $, escapeHtml, plural } from './dom.js'

const TAGS = { gmf: 'GMF', gmfu: 'GMF-U', hosp: 'H' }

export function initList({ flyTo }) {
  $('listClear').addEventListener('click', () => setListOpen(false))
  renderList(flyTo)
}

export function renderList(flyTo) {
  const state = getState()
  const app = $('app')
  const body = $('listBody')

  if (!state.listOpen) {
    app.classList.remove('listopen')
    // Vidée à la fermeture : garder 810 lignes en mémoire ne sert à rien, et
    // elles seraient périmées à la réouverture.
    body.replaceChildren()
    return
  }

  const items = visibleEstablishments(
    state.establishments,
    state.records,
    state.statusFilters,
    state.typeFilters,
  )

  $('listTitle').textContent = `${items.length} ${plural(items.length, 'résultat')}`

  // Un fragment plutôt que 700 insertions successives : un seul reflow.
  const fragment = document.createDocumentFragment()
  for (const est of items) {
    const status = state.records.get(recordKey(est.kind, est.id))?.status || 'prospect'
    const row = document.createElement('div')
    row.className = 'lrow'
    row.innerHTML =
      `<span class="ldot d-${status}"></span>` +
      '<span class="ltx">' +
      `<span class="lnm">${escapeHtml(est.nom)}</span>` +
      `<span class="lmun">${escapeHtml(est.mun)}</span>` +
      '</span>' +
      `<span class="ltag t-${est.kind}">${TAGS[typeOf(est)]}</span>`
    row.addEventListener('click', () => {
      flyTo(est, 13)
      select(est.kind, est.id)
    })
    fragment.appendChild(row)
  }

  body.replaceChildren(fragment)
  app.classList.add('listopen')
}
